import React from 'react'

import type { ToolbarProps as RBCToolbarProps } from 'react-big-calendar'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import Button from '@/components/common/Button'

export interface ToolbarProps extends RBCToolbarProps {}

export const Toolbar: React.FC<ToolbarProps> = ({
  label,
  view,
  onNavigate,
  onView,
}) => {
  const navButtons = (
    <div className="flex items-center gap-x-2">
      <Button
        className="h-7 w-7 bg-white dark:bg-default-dark"
        type="button"
        variant="outline"
        onClick={() => onNavigate('PREV')}
      >
        <div>
          <HiOutlineChevronLeft className="w-4 h-4" />
        </div>
      </Button>
      <Button
        className="px-4 h-7 bg-white dark:bg-default-dark"
        type="button"
        variant="outline"
        onClick={() => onNavigate('TODAY')}
      >
        <span className="text-sm font-medium">Today</span>
      </Button>
      <Button
        className="h-7 w-7 bg-white dark:bg-default-dark"
        type="button"
        variant="outline"
        onClick={() => onNavigate('NEXT')}
      >
        <div>
          <HiOutlineChevronRight className="w-4 h-4" />
        </div>
      </Button>
    </div>
  )
  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-x-2 gap-y-4 pb-4">
      <div className="hidden md:block">{navButtons}</div>
      <div className="flex items-center justify-center w-full h-7 bg-white dark:bg-default-dark rounded-md border border-primary-300 dark:border-primary-700">
        <span className="text-sm font-medium text-primary-900 dark:text-primary-100">
          {label}
        </span>
      </div>
      <div className="flex items-center justify-between w-full md:w-fit">
        <div className="md:hidden">{navButtons}</div>
        <div className="flex h-7 rounded-md border border-primary-300 dark:border-primary-700 divide-x divide-primary-300 dark:divide-primary-700">
          <button
            className={twMerge(
              'flex items-center justify-center h-full px-2 hover:bg-primary-100 dark:hover:bg-primary-800',
              view === 'month'
                ? 'bg-primary-100 dark:bg-primary-800'
                : 'bg-white dark:bg-default-dark',
              'rounded-l-[5px]',
            )}
            onClick={() => onView('month')}
          >
            <span className="text-sm font-medium text-primary-900 dark:text-primary-100">
              Month
            </span>
          </button>
          <button
            className={twMerge(
              'flex items-center justify-center h-full px-2 hover:bg-primary-100 dark:hover:bg-primary-800',
              view === 'agenda'
                ? 'bg-primary-100 dark:bg-primary-800'
                : 'bg-white dark:bg-default-dark',
              'rounded-r-[5px]',
            )}
            onClick={() => onView('agenda')}
          >
            <span className="text-sm font-medium text-primary-900 dark:text-primary-100">
              Agenda
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
